import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Container, Row, Col, Spinner, Alert, Card } from 'react-bootstrap';
import api from './Api';
import Cookies from 'js-cookie';
import Header from './Header';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      setError('⚠️ Please fill in all fields');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const data  = await api.post('/auth/generateToken', { username, password });

      if (data) {
        // Cookie expires when the JWT expires (1 hour), matching server-side expiry
        const cookieOptions = {
          secure: true,
          sameSite: 'Strict',
          expires: new Date(new Date().getTime() + 60 * 60 * 1000), // 1 hour
        };
        Cookies.set('jwtToken', data?.token, cookieOptions);
        Cookies.set('userRole', data?.role, cookieOptions);
        Cookies.set('username', data?.username, cookieOptions);
        Cookies.set('name', data?.name, cookieOptions);
        Cookies.set('loginTime', new Date().toISOString(), cookieOptions);

        if (data?.role === 'ROLE_ADMIN' || data?.role === 'ROLE_WRITER') {
          navigate('/writerdash');
        } else if (data?.role === 'ROLE_USER') {
          navigate('/');
        }
      } else {
        setError('❌ Invalid username or password');
      }
    } catch (err) {
      setError('❌ Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Header />
      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col md={5} lg={4}>
            <Card className="shadow-lg rounded-3 p-4 animate__animated animate__fadeIn">
              <Card.Body>
                <h2 className="text-center mb-4 fw-bold">Welcome Back 👋</h2>
                <p className="text-center text-muted mb-4">
                  Please login to continue to your account
                </p>

                {error && <Alert variant="danger">{error}</Alert>}

                <Form onSubmit={handleLogin}>
                  <Form.Group controlId="formUsername" className="mb-3">
                    <Form.Label>Username</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter your username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group controlId="formPassword" className="mb-4">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100 fw-semibold"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <Spinner animation="border" size="sm" /> Logging in...
                      </>
                    ) : (
                      'Login'
                    )}
                  </Button>
                </Form>

                <div className="text-center mt-3">
                  Don't have account, Register <a href="/register" className="text-muted small">
                    here
                  </a>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
